import { Button } from '@chakra-ui/react';
import { BigNumber } from '@ethersproject/bignumber';
import { InMobile } from '@ui/components/MobileOrDesktop';
import { SlidablePanel } from '@ui/components/SlidablePanel';
import { VaultsPieChart } from '@ui/components/VaultsPieChart';
import { VaultsInfo } from '@ui/components/VenoInfoView/VaultsInfo';
import {
  useVenoFountainHarvest,
  useVenoReservoirHarvest,
} from '@ui/hooks/useVenoHarvest';
import { useTranslations } from '@ui/i18n';
import { PRELAUNCH } from '@ui/utils/constants';
import { SwiperSlide } from 'swiper/react';

import Features from '../Features';
import GardenInfoView from './GardenInfoView';
import { useVenoFountainData, useVenoReservoirData } from './useVenoInfoData';

export const VenoInfoView = () => {
  const t = useTranslations();
  const venoReservoirData = useVenoReservoirData(!PRELAUNCH);
  const venoFountainData = useVenoFountainData(!PRELAUNCH);

  const {
    mutate: venoReservoirHarvest,
    isLoading: isVenoReservoirHarvestLoading,
  } = useVenoReservoirHarvest();

  const {
    mutate: venoFountainHarvest,
    isLoading: isVenoFountainHarvestLoading,
  } = useVenoFountainHarvest();

  return (
    <>
      <SlidablePanel
        title="Reservoir"
        explainer={
          <InMobile>
            {t(
              `Vest VNO for a share of Veno’s rewards, denominated in WCRO and ATOM`,
            )}
          </InMobile>
        }
        swipeDisabled={
          BigNumber.from(0).eq(venoReservoirData.lockedVno) &&
          BigNumber.from(0).eq(venoReservoirData.unlockedVno)
        }
      >
        <SwiperSlide>
          <VaultsInfo vaultType="RESERVOIR" />
        </SwiperSlide>
        <SwiperSlide>
          <VaultsPieChart
            month3={venoReservoirData.vnoAllocations[0]}
            month12={venoReservoirData.vnoAllocations[1]}
            month48={venoReservoirData.vnoAllocations[2]}
            month96={venoReservoirData.vnoAllocations[3]}
          />
        </SwiperSlide>
      </SlidablePanel>
      {!venoReservoirData.pendingRewardsMap ||
      venoReservoirData.pendingRewardsMap.wcro.lte(BigNumber.from(0)) ? null : (
        <Button
          variant="primary"
          isLoading={isVenoReservoirHarvestLoading}
          onClick={() => venoReservoirHarvest()}
        >
          {t('Harvest {pool} rewards', {
            pool: 'Reservoir',
          })}
        </Button>
      )}
      <SlidablePanel
        title="Fountain"
        mt="60px"
        explainer={
          <InMobile>
            {t(`Vest VNO for more rewards, denominated in VNO`)}
          </InMobile>
        }
        swipeDisabled={
          BigNumber.from(0).eq(venoFountainData.lockedVno) &&
          BigNumber.from(0).eq(venoFountainData.unlockedVno)
        }
      >
        <SwiperSlide>
          <VaultsInfo vaultType="FOUNTAIN" />
        </SwiperSlide>
        <SwiperSlide>
          <VaultsPieChart
            month3={venoFountainData.vnoAllocations[0]}
            month12={venoFountainData.vnoAllocations[1]}
            month48={venoFountainData.vnoAllocations[2]}
            month96={venoFountainData.vnoAllocations[3]}
          />
        </SwiperSlide>
      </SlidablePanel>
      {!venoFountainData.pendingRewards ||
      venoFountainData.pendingRewards.lte(BigNumber.from(0)) ? null : (
        <Button
          variant="primary"
          isLoading={isVenoFountainHarvestLoading}
          onClick={() => venoFountainHarvest()}
        >
          {t('Harvest {pool} rewards', {
            pool: 'Fountain',
          })}
        </Button>
      )}
      <Features.Garden>
        <GardenInfoView />
      </Features.Garden>
    </>
  );
};
